import axios from 'axios'

const flowInstance = axios.create({
  baseURL: process.env.REACT_APP_FLOW_API,
  headers: {
    'content-type': 'multipart/form-data',
  },
})

const webPayInstance = axios.create({
  baseURL: process.env.REACT_APP_WEBPAY_API,
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
})

const mercadoPagoInstance = axios.create({
  baseURL: process.env.REACT_APP_MERCADO_PAGO_API,
  headers: {
    'content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers':
      'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method',
    'access-control-allow-methods': 'GET, POST, OPTIONS, PUT, DELETE',
  },
})

export { flowInstance, mercadoPagoInstance, webPayInstance }
